

export default function Loading(){

    return (
        <div className={"loading-container"}>
            <img src={"/images/loading-animation.gif"} width={"200"} height={"200"} alt={"Loading animation image"} />
        </div>
    )
}